import {compose, withProps} from 'react-recompose';

import {connect} from 'react-redux';
import config from '../../config';
import {getTravelZoneCountries} from '../../lib/country-utils.js';
import formatAmount from '../../lib/formatAmount';
import I18n from '../../lib/i18n';
import {customPaymentMeanSelector} from '../../modules/Customer/selectors';
import {travelZoneSelector} from '../../modules/International/Travel';
import {isLoadingSelector} from '../../modules/LoadingStatus';
import {
  availableTopUpsSelectorForType,
  selectedTopUpsPriceSelector,
} from '../../modules/TopUps';
import {fetchAvailableTopUps} from '../../modules/TopUps/actions';
import {
  voucherCurrentVoucherDetailsSelector,
  voucherFilteredAvailableVouchersSelector,
  setVoucherDetailsComeFrom,
} from '../../modules/Voucher';
import theme from '../../theme-config';
import TopUp from './TopUp.container';
import {getVisibleNumbers} from './lib';

const mapStateToProps = state => ({
  availableTopUps: availableTopUpsSelectorForType(
    state,
    config.international.ROAMING,
  ),
  countryList: getTravelZoneCountries(
    config.iddCountries,
    travelZoneSelector(state),
  ),
  travelZone: travelZoneSelector(state),
  paymentMean: customPaymentMeanSelector(state),
  price: selectedTopUpsPriceSelector(state),
  isConfirmationLoading: isLoadingSelector(state, 'topUpConfirmation'),
  currentVoucherDetails: voucherCurrentVoucherDetailsSelector(state),
  displayVouchersForTopup: config.displayVouchersForTopup,
  filteredAvailableVouchers: voucherFilteredAvailableVouchersSelector(state),
});

const mapDispatchToProps = dispatch => ({
  fetchAvailableTopUps: () =>
    dispatch(fetchAvailableTopUps(config.international.ROAMING)),
  setVoucherDetailsComeFrom: (comeFrom: string) =>
    setVoucherDetailsComeFrom(comeFrom),
});

const modalTopUpExplanation = (
  price: number,
  paymentMean?: Object,
  walletBalance?: number,
  currentVoucherDetails?: Object,
) => {
  if (price) {
    const formattedPrice = formatAmount(price);

    if (walletBalance && walletBalance - price >= 0) {
      const textContent = I18n.t(
        currentVoucherDetails
          ? 'TravelTopUp.modalTopUpExplanation.walletVoucher'
          : 'TravelTopUp.modalTopUpExplanation.wallet',
        {
          price: formattedPrice,
        },
      );
      return textContent;
    }

    if (paymentMean) {
      const textContent = I18n.t(
        currentVoucherDetails
          ? 'TravelTopUp.modalTopUpExplanation.creditCardVoucher'
          : 'TravelTopUp.modalTopUpExplanation.creditCard',
        {
          cardNumber: getVisibleNumbers(paymentMean?.functionalId),
          price: formatAmount(price),
        },
      );
      return textContent;
    }
  }
};

const footerTopUpExplanation = (price: number, walletBalance?: number) => {
  let paymentMean = I18n.t('paymentMean.CREDIT_CARD.name').toLowerCase();

  if (walletBalance && walletBalance - price >= 0) {
    paymentMean = I18n.t('paymentMean.WALLET.name');
    return I18n.t('TravelTopUp.footerTopUpExplanation', {paymentMean});
  }

  return I18n.t('TravelTopUp.footerTopUpExplanation', {paymentMean});
};

const withTravelTopUpProps = ({
  travelZone,
  paymentMean,
  price,
  currentVoucherDetails,
}) => ({
  confirmButtonText: I18n.t('Dashboard.TopUp.topUpNow'),
  headerTextLine1: I18n.t('TravelTopUp.textLine1', {travelZone}),
  headerTitle: I18n.t('TravelTopUp.zone', {travelZone}),
  iconColor: theme.topUp.header.iconColor,
  headerImage: theme.travelImage,
  iconName: 'phone-plane',
  orderType: 'TOPUP',
  orderSummaryTitle: I18n.t('TravelTopUp.title'),
  modalTopUpExplanation: (walletBalance?: number) =>
    modalTopUpExplanation(
      price,
      paymentMean,
      walletBalance,
      currentVoucherDetails,
    ),
  footerTopUpExplanation: (walletBalance?: number) =>
    footerTopUpExplanation(price, walletBalance),
  getSelectedVoiceTopUp: selectedTopUp =>
    selectedTopUp.find(product => product.name?.includes('VOICE')),
});

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  withProps(withTravelTopUpProps),
)(TopUp);
